const statusFactStyles = theme => ({
  color: theme.palette.table.body,
  fontSize: theme.typography.body2.fontSize,
  flexBasis: '25%',
  lineHeight: 1.5,
  marginBottom: 8
});

export default statusFactStyles;
